<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
  
      <!------------------------search---------------------->
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:10%">
	        <el-select v-model="query.clerkid" clearable filterable placeholder="全部销售员" @change="isselect=true">
	          <el-option label="全部销售员" value="0"></el-option>
	          <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
	        </el-select> 
          </el-form-item>
          <el-form-item style="width:10%">
            <el-select v-model="query.brandid" clearable filterable placeholder="按品牌">
              <el-option label="不选品牌" value=""></el-option>
              <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:10%">
            <el-cascader :options="categorylist" clearable v-model="query.catid" placeholder="选择分类"></el-cascader>
          </el-form-item>
          <el-form-item style="width:21%">
            <el-date-picker
              v-model="query.date" clearable
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd" style="width:100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item ref="query" :model="query" style="width:13%">
              <el-input placeholder="请输入关键字" style="width:100%" v-model="query.key" clearable @keyup.enter.native="getList"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
          	  <template>
          	      <span style="font-size:13px;color:rgb(230, 162, 60);float:right;margin-right:20px">商品销售合计：￥{{amounts}}</span>
          	  </template>
          </el-form-item>
        </el-form>
        <!------------------------search end---------------------->
        <div class="backborder2" style="margin-top:10px">
	        <el-table :data="lists" v-loading="listLoading">
	           <el-table-column prop="number" label="编号" width="110"></el-table-column>
	           <el-table-column prop="name" label="名称"></el-table-column>
	           <el-table-column prop="brandname" label="品牌" width="110" align="center"></el-table-column>
	           <el-table-column prop="spec" label="规格" width="110" align="center"></el-table-column>
	           <el-table-column prop="nums" label="销售数量" width="110" align="center"></el-table-column>
	           <el-table-column prop="baseunit" label="单位" width="110" align="center"></el-table-column>
	           <el-table-column prop="amount" label="合计总价" width="110" align="center"></el-table-column>
	        </el-table>
	        <div class="block">
	        <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50,1000]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	        </div>
        </div>
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Stat/index",
      transitionshow:true,
      lists:[],
      amounts:0,
      listLoading:false,
      query:{
        act:'product',
        token:this.$cookies.get('token'),
        brandid:'',
        clerkid:'',
        catid:[],
        date:[],
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_rows: 0,
      brandlists:[],
      categorylist:[],
      sellerLists:[],
    }
  },
  mounted(){
    this.getCategoryList();
    this.getBrand();
    this.getList();
    this.getSeller();
  },
  methods:{
    //重置表单
    reset() {
        this.$refs.create.resetFields();
    },
    //获取品牌
    getBrand(){
      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    //获取分类列表
    getCategoryList(){
      var resource = this.$resource(this.GLOBAL.domain+"Product/index");
      resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.categorylist = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    //信息列表
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.lists=result.lists;
          this.amounts=result.amount;
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    //获取销售员
    getSeller(){
      var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/stat/Product.vue